import { clsx } from 'clsx'
import styles from './GalleryLabel.module.scss'
import { Icon } from '@/components/Icon'
import React from 'react'

const GalleryLabel = ({ count, className }: { count: number; className?: string }) => {
  return (
    <div className={clsx(styles['gallery-container'], className)}>
      <Icon name="gallery" size={24} />
      <span className={styles['gallery-count']}>{count ?? 0}</span>
    </div>
  )
}

export default GalleryLabel
